import { createSvgIcon } from "@mui/material";

const HomeIcon = createSvgIcon(
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_638_795)">
			<path d="M9.99998 19V14H14V19C14 19.55 14.45 20 15 20H18C18.55 20 19 19.55 19 19V12H20.7C21.16 12 21.38 11.43 21.03 11.13L12.67 3.59997C12.29 3.25997 11.71 3.25997 11.33 3.59997L2.96998 11.13C2.62998 11.43 2.83998 12 3.29998 12H4.99998V19C4.99998 19.55 5.44998 20 5.99998 20H8.99998C9.54998 20 9.99998 19.55 9.99998 19Z" />
		</g>
		<defs>
			<clipPath id="clip0_638_795">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>,
	"Home",
);

export default HomeIcon;
